import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=38f8b662&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=38f8b662&prod&lang=scss"
import style1 from "./GeneralInfo.vue?vue&type=style&index=1&id=38f8b662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f8b662",
  null
  
)

export default component.exports